import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { WebsiteInterface } from '../types/website-interface';
import { WEBSITE_API } from '../api/website-api';
interface WebsiteListItemInterface extends Pick<WebsiteInterface, 'name' | 'id'> {}
export function useWebsiteListAll(t0) {
  const $ = _c(5);
  const shouldFetch = t0 === undefined ? true : t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [`${WEBSITE_API}/websites/list-all`, RequestModuleEnum.Websites];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: websiteListAll,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, shouldFetch && !!user);
  let t3;
  if ($[2] !== mutate || $[3] !== websiteListAll) {
    t3 = {
      websiteListAll,
      mutate
    };
    $[2] = mutate;
    $[3] = websiteListAll;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}